import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import { TextBox } from 'srcReact/components/common2/TextBox'
import { useTranslation } from 'react-i18next'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import Spinner from 'srcReact/components/common2/Spinner'
import Button from 'srcReact/components/common2/Button'
import { useDispatch, useSelector } from 'react-redux'
import { integrationActions } from '../../actions'
import SuccessMessage from 'srcReact/components/common2/SuccessMessage'

function SetTranslationKey({ orgId, closeModal }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [updateClicked, setUpdateClicked] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [translationKey, setTranslationKey] = useState({
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: false
  })

  const {
    integration: {
      updateTranslationKey: { loading, success, error }
    }
  } = useSelector((state) => state)
  useEffect(() => {
    if (updateClicked && !loading) {
      setUpdateClicked(false)
      if (success) {
        setSuccessMessage(t('integration.translationKeySuccess'))
        setTimeout(closeModal, 3000)
      } else if (error) {
        setTranslationKey({
          ...translationKey,
          hasError: true,
          errorMessage: error
        })
      }
    }
  }, [updateClicked, loading, success, error])

  const handleTranslationKeyChange = (e) => {
    setTranslationKey({
      ...translationKey,
      value: e.target.value
    })
  }

  const updateTranslationKey = () => {
    setUpdateClicked(true)
    dispatch(integrationActions.updateIntegrations(orgId, 'google', 'translate', 'activate', translationKey.value))
  }

  return (
    <div className={styles.translationWrapper}>
      <TextBox
        name='google_translation_key'
        fieldInfo={translationKey}
        onChange={handleTranslationKeyChange}
        customInputCss={`${styles.translatinKeyInput}`}
        size='full'
        label={t('organizationSettings.display.googleTransaltionToken')}
        labelPosition='bottom'
        customLabelCss={styles.customLabelCss}
      />
      <div className={styles.buttons}>
        <Button style='secondary' size='large' text={t('global.cancel')} handleClick={closeModal} />
        <Button disabled={loading} text={t('global.update')} size='large' handleClick={updateTranslationKey} />
      </div>

      {successMessage && <SuccessMessage className={styles.message} text={successMessage} />}
      {loading && <Spinner />}
    </div>
  )
}

export default SetTranslationKey
